<!-- Attention: when editable is true, the selectedItemTemplate gets ignored -->
<p-menu [appendTo]="'body'" #priceMenu [model]="buttonMenu" [popup]="true">
    <ng-template pTemplate="start">
        <div class="p-2 grid grid-cols-[4fr_3fr_3fr] items-center w-full min-w-0 font-semibold">
            <div class="pr-3 break-words whitespace-normal min-w-0">
                <span class="">
                    {{
                        ('common.price' | translate) + ' ' + (this.lineItem()?.unitIdentifier ?? '')
                    }}
                    <!-- this is the prices -->
                </span>
                @if (
                    this.lineItem()?.baseUnit?.identifier &&
                    this.lineItem()?.baseUnit?.identifier !== this.lineItem()?.unitIdentifier
                ) {
                    <span class="text-slate-400">
                        {{ '/' + this.lineItem()?.baseUnit?.identifier }}
                        <!-- this is the prices -->
                    </span>
                }
            </div>
            <div class="px-4 flex min-w-0">{{ 'document.price-list' | translate }}</div>
            <div class="pl-3 break-words whitespace-normal min-w-0">
                {{ 'common.minQuantity' | translate }}
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="item" let-item>
        <div
            class="px-2 py-1 grid grid-cols-[4fr_3fr_3fr] items-center w-full min-w-0"
            [ngClass]="{
                'font-bold': item.pricePerConversion
                    ? this.ngModelWithDecimalPlaces() == item.pricePerConversion
                    : this.ngModelWithDecimalPlaces() == item.priceUnit
            }"
        >
            <div class="pr-3 break-words border-r border-gray-600 whitespace-normal min-w-0">
                <i class="fa-solid fa-circle me-1" [style.color]="item.iconStyle?.color"></i>
                @if (
                    item.pricePerConversion &&
                    this.lineItem()?.baseUnit?.identifier !== this.lineItem()?.unitIdentifier
                ) {
                    <span>
                        {{ item.pricePerConversion }}
                        <!-- this is the prices -->
                    </span>
                    <span class="text-slate-400">{{ ' / ' }}</span>
                }
                <span
                    [ngClass]="{
                        'text-slate-400':
                            this.lineItem()?.baseUnit?.identifier !==
                            this.lineItem()?.unitIdentifier
                    }"
                >
                    {{ item.priceUnit }}
                    <!-- this is the prices -->
                </span>
            </div>

            <div class="px-4 border-r border-gray-600 flex min-w-0">
                {{ item.priceList }}
            </div>
            <div class="pl-3 break-words whitespace-normal min-w-0">
                <span *ngIf="item.minimumQuantityPerConversion" class="">{{
                    item.minimumQuantityPerConversion
                }}</span>
                <span
                    *ngIf="item.minimumQuantityPerConversion && item.minimumQuantity"
                    class="text-slate-400"
                    >{{ ' / ' }}</span
                >
                <span
                    *ngIf="item.minimumQuantity"
                    [ngClass]="{
                        'text-slate-400':
                            this.lineItem()?.baseUnit?.identifier !==
                            this.lineItem()?.unitIdentifier
                    }"
                    >{{ item.minimumQuantity }}</span
                >
            </div>
        </div>
    </ng-template>
</p-menu>
<app-phx-input-number
    [disabled]="disabled()"
    [decimalPlaces]="lineItem()?.decimalPlaces"
    [(ngModel)]="ngModel"
    [inputStyleClass]="
        lineItem()?.priceSource == PriceSourceType.MANUALPRICE ? '!text-orange-400' : ''
    "
    (valueChange)="onPriceInputChange($event)"
    [upDownButtons]="upDownButtons()"
    [dataTestId]="'phx-price-input'"
>
    @if (productPriceInfos()?.length > 0) {
        <ng-template #endInputGroupAddonContent>
            <button
                pButton
                type="button"
                icon="fa fa-caret-down"
                [disabled]="disabled()"
                (click)="priceMenu.toggle($event)"
            ></button>
        </ng-template>
    }
</app-phx-input-number>
